import React, { Component } from "react";

class StatusCanceledSVG extends React.Component {
  render() {
    return (
      <svg
        className={"svg-container " + this.props.svgClassName}
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 16 16"
      >
        <path
          className="svg"
          d="M15.4,0H0.6C0.3,0,0,0.3,0,0.6v5.1c0,0.3,0,6.2,0,6.2v3.6C0,15.8,0.3,16,0.6,16h14.9c0.3,0,0.6-0.3,0.6-0.6V0.6
	C16,0.3,15.7,0,15.4,0z M14.9,14.9H1.1v-3V5.7V1.1h13.8V14.9z M3.7,12.7c-0.1,0-0.3-0.1-0.4-0.2c-0.2-0.2-0.2-0.6,0-0.8l6.1-6.1
	c0.2-0.2,0.6-0.2,0.8,0c0.2,0.2,0.2,0.6,0,0.8l-6.1,6.1C4,12.6,3.9,12.7,3.7,12.7z M10.4,12.1c0,0.1-0.1,0.3-0.2,0.4
	c-0.2,0.2-0.6,0.2-0.8,0L3.3,6.4c-0.2-0.2-0.2-0.6,0-0.8c0.2-0.2,0.6-0.2,0.8,0l6.1,6.1C10.3,11.8,10.4,12,10.4,12.1z M8.6,3
	c0,0.4-0.4,0.8-0.8,0.8S7,3.4,7,3s0.4-0.8,0.8-0.8S8.6,2.5,8.6,3z M11.2,3c0,0.4-0.4,0.8-0.8,0.8S9.6,3.4,9.6,3s0.4-0.8,0.8-0.8
	S11.2,2.5,11.2,3z M13.7,3c0,0.4-0.4,0.8-0.8,0.8c-0.4,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8C13.4,2.2,13.7,2.5,13.7,3z"
        />
      </svg>
    );
  }
}

export default StatusCanceledSVG;



// WEBPACK FOOTER //
// ./src/svg/StatusCanceledSVG.jsx